import { pathOr } from "ramda";

export const permissionSet = (state, id) =>
  pathOr({}, [], state.accounts.permissionSets.list.find(l => l.id === id));
